import { ContentReportFormStep } from "Components/Support/ContentReport/ContentReportFormStep";
import type { ContentReportFormData } from "Components/Support/ContentReport/contentReportSchema";
import type { ContentReportStep } from "Components/Support/ContentReport/ContentReportStep";
import type { ContentReportTarget } from "Components/Support/ContentReport/ContentReportTarget";
import type { SupportFlowResult } from "Components/Support/SupportFlowResult";
import { SupportFlowResultStep } from "Components/Support/SupportFlowResultStep";
import type { SupportFormStatus } from "Components/Support/SupportFormStatus";

type Props = {
  step: ContentReportStep;
  target: ContentReportTarget;
  result: SupportFlowResult | null;
  retryValues: ContentReportFormData | undefined;
  onStatusChange: (status: SupportFormStatus) => void;
  onSubmitted: (
    result: SupportFlowResult,
    submittedValues: ContentReportFormData,
  ) => void;
};

/**
 * The body of one step of the notice dialog. A module-level component on purpose: defined
 * inside the dialog it would get a new identity per render and remount the form — and wipe
 * what was typed — on every status update.
 */
export const ContentReportStepContent = ({
  step,
  target,
  result,
  retryValues,
  onStatusChange,
  onSubmitted,
}: Props) => {
  if (step === "form") {
    return (
      <ContentReportFormStep
        target={target}
        defaultValues={retryValues}
        onStatusChange={onStatusChange}
        onSubmitted={onSubmitted}
      />
    );
  }

  if (!result) {
    return null;
  }

  return <SupportFlowResultStep result={result} />;
};
